import replaceCartContent from '../../../cart/replaceCartContent';
let memberUpdateHandled = false;

async function handleMemberCart(e) {
  if (e) {
    if (e?.type === 'member-updated') {
      if (memberUpdateHandled) return;
      memberUpdateHandled = true;
    }
  }
  const body = document.querySelector('body');
  const { attributes } = await Shopify.functions.getCart();
  const isLoggedIn = body.dataset.loggedIn === 'true';
  const isAlreadyMember = attributes["_is_club_member"] === 'true' || attributes["_is_club_member"] === true;
  if (isLoggedIn && !isAlreadyMember) {
    attributes["_is_club_member"] = 'true';
    await Shopify.functions.updateCartAttributes(attributes);
    return setTimeout(replaceCartContent)
  }
  else if (!isLoggedIn && isAlreadyMember) {
    attributes["_is_club_member"] = 'false';
    await Shopify.functions.updateCartAttributes(attributes);
  }

  return setTimeout(replaceCartContent)
}

handleMemberCart();
document.addEventListener('member-updated', (e) => handleMemberCart(e));
document.addEventListener('member-updated__from-toggle', (e) => handleMemberCart(e));